import { Input } from 'components'
import { useRecoilState } from 'recoil'
import { editCaseFieldSelector } from 'atoms'
import { useState, useEffect } from 'react'

export const CaseArrayWrapper = ({
  name,
  label,
  width,
  index,
  elementRight,
  margin,
}) => {
  const [localValue, setLocalValue] = useState('')
  const [recoilValue, setRecoilValue] = useRecoilState(
    editCaseFieldSelector({ name: name, path: `value[${index}]` }),
  )

  useEffect(() => {
    setLocalValue(recoilValue || '')
  }, [recoilValue])

  const handleChange = (value) => {
    setLocalValue(value)
    setRecoilValue(value)
  }

  return (
    <Input
      width={width}
      margin={margin || '0 24px 24px 0'}
      padding={'12px 35px 12px 16px'}
      label={label}
      value={[localValue, handleChange]}
      elementRight={elementRight}
    />
  )
}

export default CaseArrayWrapper
